// main.tsx - point d'entrée de la landing.
// @hop-resto/ui d'abord : variables CSS, keyframes globales ET Nunito, la
// police de TOUTE la page. Puis Modulus Pro (titres de section uniquement),
// puis le thème local de la landing.
import "@hop-resto/ui";
import "./fonts";
import "./landing.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found");

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
